// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "./Cn.bs.js";

var cx = Cn.make;

export {
  cx ,
  
}
/* No side effect */
